<template>
  <div class="personal">
    <Nav />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
             <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <!-- <div class="personal-bottom-bottom-right-top-left"></div> -->
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item
                class="maxtitle"
                :to="{ path: '/lishiguankan' }"
              >
              <div class="title_box">
                 <span class="lines"></span>
                 <span>历史观看</span>
               </div>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="care_list" v-if="historyData.list">
              <div
                class="care_items"
                v-for="(item, index) in historyData.list"
                :key="index"   >
                <div class="care_liveimg">
                  <img :src="item.item.cover" alt="" />
                </div>
                <div class="care_items_right">
                  <div class="name" v-if="item.item.title">
                    {{ item.item.title }}
                  </div>
                  <div class="name" v-else>主播有点懒,暂无标题～</div>
                  <div class="care_user">
                    <div class="care_user_img">
                      <img :src="item.user.avatar" alt="" />
                    </div>
                    <div class="care_user_title">
                      {{ item.user.nickname }}
                    </div>
                  </div>
                  <div class="date_look">
                    {{ dateFormat(item.viewTime) }}
                  </div>
                </div>
              </div>
              <div class="emitData" v-if="historyData.list && historyData.list.length ==0">
                <img src="/static/person/order_emit.png" alt="">
                <div>暂无观看记录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
import slide from './template_slide.vue'
export default {
  name: "App",
  data() {
    return {
      b: 0,
      historyData: [],
      activeName: 0,
    };
  },
  mounted() {
    this.$axios({
      url: this.api + "/v1/list/history",
      method: "GET",
      headers: {
        device: "web",
        packageId: "1",
        version: "1.0.0",
        channel: "web",
        "authToken": localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      console.log(res);
      this.historyData = res.data.data;
    });
  },
  methods: {
      changeSlide(data){
              this.$router.push(data);
            },
    dateFormat: function (time) {
      var times = time * 1000;
      var date = new Date(times);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    dianji(e) {
      this.b = e;
    },
    Mingcheng(e, i) {
      console.log(e, i);
      if (e == 0 && i == 0) {
        this.$router.push("/personalc");
      }
      if (e == 0 && i == 1) {
        this.$router.push("/wodeguanzhu");
      }
      if (e == 0 && i == 2) {
        this.$router.push("/wodefensi");
      }
      // if (e==0&&i==3) {
      //     this.$router.push('/lishiguankan')
      // }
      if (e == 0 && i == 4) {
        this.$router.push("/wodezichan");
      }
      if (e == 0 && i == 5) {
        this.$router.push("/wodexinxi");
      }
      if (e == 1 && i == 0) {
        this.$router.push("/shezhiguanliyuan");
      }
      if (e == 1 && i == 1) {
        this.$router.push("/guanlijinyan");
      }
      if (e == 1 && i == 2) {
        this.$router.push("/tianjiazhiboyuan");
      }
      if (e == 2 && i == 0) {
        this.$router.push("/wodeshouyi");
      }
      if (e == 2 && i == 1) {
        this.$router.push("/yonghupaihangbang");
      }
      // if (e == 3&&i == 0) {
      //     this.$router.push('/shipinfabu')
      // }
      // if (e == 3&&i == 1) {
      //     this.$router.push('/ziyuanguanli')
      // }
      if (e == 3 && i == 0) {
        this.$router.push("/zhiboshuju");
      }
      // if (e==4&&i==1) {
      //     this.$router.push('/shipinshuju')
      // }
    },
  },
  components: {
    Nav,
     slide,
  },
};
</script>

<style scoped lang='scss'>
.a {
  background-color: #721edc;
}
.xzcxzcxz {
  color: white;
}
.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.emitData{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top:20%;
}
.personal {
  width: 100vw;
  background: #f7f8fa;
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .title_box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .lines {
        display: inline-block;
        width: 4px;
        margin-right: 6px;
        border-radius: 4px;
        height: 20px;
        background: #721edc;
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
    }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}
.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  flex: 2;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px 0 20px;
  box-sizing: border-box;
  margin-top: 16px;
}
.personal-bottom-bottom-right-top {
  background-color: #fff;
  display: flex;
  align-items: center;
  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .xinxi:hover {
    color: #721edc;
  }
}

.personal-bottom-bottom-right-bottom {
  box-sizing: border-box;
  height: calc(94% - 15px);
  margin-top: 25px;
  padding-top: 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
  .care_list {
    width: calc(100% + 45px);
    height: calc(100% + 45px);
    overflow: scroll;
  }
  .care_items {
    display: flex;
    padding: 20px 0;
    width: 100%;

    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .care_items_row {
    width: 75%;
    display: flex;
    align-items: center;
    margin: 20px 24px;
  }
  .care_items_right {
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    box-sizing: border-box;
    justify-content: space-between;
    .care_user {
      margin-top: 10px;
      display: flex;
      align-items: center;
    }
    .care_user_img {
      border-radius: 50%;
      width: 20px;
      height: 20px;
      img {
        border-radius: 50%;
        width: 20px;
        height: 20px;
      }
    }
    .care_user_title {
      margin-left: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .date_look {
        flex: 3;
       display: flex;
       align-items: flex-end;
      margin-top: 10px;
      color: #a6a6a6;
      font-size: 14px;
    }
    .name {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .desc {
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .care_liveimg {
    width: 224px;
    height: 126px;
    margin-right: 12px;
    overflow: hidden;
    border-radius: 4px;
    img {
      width: 224px;
      height: 126px;
      border-radius: 4px;
    }
  }
  .care_items_headers {
    width: 70px;
    height: 70px;
    margin-right: 10px;
    border-radius: 50%;
    img {
      border-radius: 50%;

      width: 70px;
      height: 70px;
    }
  }
}
.daohang {
  display: flex;
  color: white;
  width: 500px;
  //   margin-left: 20px;
}

.maxtitle {
  font-size: 20px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600 !important;
  color: #333333;

  span {
    font-weight: 600 !important;
    color: #333333;
  }
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.personal-bottom-bottom-right-bottom-top {
  /* width: 100%; */
  display: flex;
  height: 130px;
  border-bottom: 1px #464646 solid;
}
.personal-bottom-bottom-right-bottom-center1 {
  margin-top: 15px;
  height: 100px;
  border-bottom: 1px #464646 solid;
}
.personal-bottom-bottom-right-bottom-center2 {
  margin-top: 15px;
  /* height: 100px; */
  width: 100%;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
</style>
<style>
.xzcxzcxz {
  color: white;
}
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}
.personal-bottom-bottom-left .is-active {
  color: #721edc;
}
.personal-bottom-bottom-left .el-collapse {
  border-top: 0px solid #f7f8fa;
  width: 100%;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/component/Lishiguankan.vue